import type { ProductEntity, ProductsQueryItemModel } from '../model/types'

import { omitAll } from 'lodash/fp'

export const unwrapPricingLine = (
	line: ProductsQueryItemModel
): ProductEntity[] =>
	line.products.map(
		(product) =>
			({
				...product,
				...omitAll(['products', 'fields.aggregated_fields'], line),
			}) as unknown as ProductEntity
	)
export const unwrapLines = (
	collection: ProductsQueryItemModel[] = []
): ProductEntity[] => {
	let products: ProductEntity[] = []
	for (let i = 0; i < collection?.length; i++) {
		products = products.concat(unwrapPricingLine(collection[i]) as any)
	}

	return products
}
